<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="info.salesman_id?'修改业务经理':'绑定业务经理'"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="100px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="业务经理" prop="salesman_id">
        <el-select
          filterable
          size="mini"
          v-model="form.data.salesman_id"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in saleManList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >保存</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          salesman_id: "",
        },
        rules: {
          salesman_id: [
            { required: true, message: "请选择", trigger: "change" },
          ],
        },
      },
      info: {},
      saleManList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$http
        .get("/admin/salesman/list", { params: { page: 1, count: 9999 } })
        .then((res) => {
          if (res.code === 1) {
            this.saleManList = res.data.list;
          }
        });
    },
    reset(done) {
      this.$nextTick(() =>{
        this.form.data.salesman_id = '';
        this.info = {};
        this.$refs.elFormDom.resetFields();
        done && done();
      })
    },
    toggle(show) {
      if(show) {
        this.form.data.salesman_id = '';
      }
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      if(row.salesman_id) {
        this.form.data.salesman_id = row.salesman_id;
      }
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _params = {
            ...this.form.data,
            id: this.info.id,
          };
          this.$http
            .post("/admin/merchant/bindSalesman", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
                this.$message.success("操作成功");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.idPhoto .avatar {
  width: 100% !important;
}
.idPhoto .avatar-uploader-icon {
  width: 260px !important;
  height: 170px !important;
  line-height: 170px !important;
  border: 1px dashed #d9d9d9;
}
.onBtn-large {
  display: flex;
  justify-content: center;
}
</style>
